import { EvaluationsList } from './components/EvaluationsList';
import { Flex } from 'antd';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTable } from '@refinedev/antd';
import type { IProfessorAreaClassroom } from 'interfaces/professor_area_classrooms';
import type { IProfessorAreaEvaluationsList } from 'interfaces/professor_area/evaluations';

export const EVALUATIONS_PER_PAGE = 5;

interface TabEvaluationsProps {
  classroomRecord: IProfessorAreaClassroom;
}

export const TabEvaluations = ({ classroomRecord }: TabEvaluationsProps) => {
  const { id } = useParams();
  const { tableProps, setCurrent } = useTable<IProfessorAreaEvaluationsList>({
    resource: 'professor_area/classroom_assessments',
    meta: { classroomId: id },
    pagination: {
      pageSize: EVALUATIONS_PER_PAGE
    },
    filters: {
      permanent: [
        {
          operator: 'eq',
          field: 'filter[by_evaluation_type]',
          value: 'Assessment'
        }
      ]
    }
  });

  const handleChangePage = useCallback(
    (page: number) => {
      setCurrent(page);
    },
    [setCurrent]
  );

  return (
    <Flex vertical>
      <EvaluationsList
        tableProps={tableProps}
        onChangePage={handleChangePage}
        refetch={() => setCurrent(1)}
        disciplineId={classroomRecord.discipline_id}
      />
    </Flex>
  );
};
